import { render, staticRenderFns } from "./password-set.vue?vue&type=template&id=c3824d92"
import script from "./password-set.vue?vue&type=script&lang=js"
export * from "./password-set.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3824d92')) {
      api.createRecord('c3824d92', component.options)
    } else {
      api.reload('c3824d92', component.options)
    }
    module.hot.accept("./password-set.vue?vue&type=template&id=c3824d92", function () {
      api.rerender('c3824d92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/login/components/reset-password/password-set.vue"
export default component.exports